import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EvaButton} from "./eva-button";

@Component({
    selector: 'eva-button',
    templateUrl: './eva-button.component.html',
})
export class EvaButtonComponent {

    @Input() button: EvaButton;
    @Output() action:EventEmitter<any> = new EventEmitter<any>();

    constructor() { }

    callback(){
        this.action.next();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-button/eva-button.component.ts